import axios from 'axios'

const API_PATH = 'admins/commerce_partners/products'

const CommercePartnerProductsApi = {
  /**
   * Create commerce partner product.
   * Invoke `POST /admins/commerce_partners/:id/products/:id`
   * Note : because we put the `commerce_partner` id on the URL, the API_PATH
   * needs to be broken down first and rejoined again with the ID
   * @param {Number} productId - ID of product that want to be created in the commerce partner site
   * @param {Number} commercePartnerId - ID of commerce partner stored in Commerce::Partner
   */
  create: async ({
    productId,
    commercePartnerId
  }) => {
    // split the API_PATH
    const url = API_PATH.split('/')

    // 1. insert the commerce partner ID between `commerce_partners` and `products`
    // 2. add the productId to the end of the URL
    url.splice(2, 0, commercePartnerId)
    url.push(productId)

    // rejoining the parameterized URL
    const paramUrl = url.join('/')

    const response = axios.post(paramUrl)
    return response
  }
}

export default CommercePartnerProductsApi
